import { lazy } from "react";

export { CAREER_PATH } from "./path";
export const CareerPage = lazy(() => import("./page"));
